function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 14,
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 20 14"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7z",
  style: {
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "#fff"
  },
  transform: "translate(-2 -5)",
  vectorEffect: "non-scaling-stroke"
}));
export default SvgNextArrow;